/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* React */
import React, { useEffect, useMemo, useState } from 'react';

/* Translation */
import { useTranslation } from 'react-i18next';

/* Dependencies */
import { CopyToClipboard } from 'react-copy-to-clipboard';

/* Styled Components */
import {
  ClassroomContainer,
  ClassroomName,
  ClassroomImg,
  StudentCount,
  StyledClassCode,
  StyledDropdown,
  DropdownContainer,
  Overlay,
  Dots,
  Copy,
  CoverLetter,
  StylesImageModalResultsUpdateMember,
} from './styles/ClassroomItem';

/* Components */
import { Dropdown, Modal } from 'lego-dist';

/* Views */
import DeleteClassroomView from 'views/DeleteClassroomView';

/* Services, Hooks, Constants */
import { useRouter } from 'routes';
import GroupService from 'services/GroupService';

/* Images, Icons */
import Tooltip from '../Staff/Manage/Tooltip';
import RendererIf from 'components/RendererIf';

import updateErrorImage from 'images/error.svg';
import updateSuccessImage from 'images/checked.svg';
import ResultActionModal from 'components/shared/ResultActionModal/ResultActionModal';

interface ClassroomItemProps {
  classroom: any;
  handleAddStudent: any;
  coreClassrooms: any;
  handleOnDeleteClassroom?: any;
  canDeleteItem?: boolean;
  canAddStudents?: boolean;
}

const groupService = GroupService.getInstance();

const ClassroomItem: React.FC<ClassroomItemProps> = ({
  classroom,
  handleAddStudent,
  coreClassrooms,
  handleOnDeleteClassroom,
  canDeleteItem = false,
  canAddStudents = false,
}) => {
  const { name, id, logo, external_id: externalId } = classroom;
  const { t: translate } = useTranslation();
  const { navigateTo, currentParamsRef } = useRouter();

  const {
    current: { centerId, centerName },
  } = currentParamsRef;

  const studentsLength = useMemo(
    () => classroom.api_data?.external_data?.total_babies
      || classroom?.external_data?.total_babies || 0,
    [classroom],
  );

  /* open modals */
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [showResultActionModal, setShowResultActionModal] = useState<any>(
    false,
  );

  /* shorten center name to only display max. 70 characters */
  const truncateString = (str: string) => {
    if (str.length <= 70) {
      return str;
    }
    return `${str.slice(0, 70)}...`;
  };

  /* COPY class code */
  const [copy, setCopy] = useState<boolean>(false);
  const [code, setCode] = useState<any>('');
  const [action, setAction] = useState<string>('');

  useEffect(() => {
    if (action === 'copy') {
      setTimeout(() => {
        setAction('');
      }, 1500);
    }
  }, [action]);

  const handleClassCode = (groupId: any) => {
    const [result] = coreClassrooms?.filter((item: any) => item.id.toString() === groupId);

    setCode(result?.public_id);
  };

  useMemo(() => {
    if (classroom && coreClassrooms) {
      handleClassCode(externalId);
    }
  }, [classroom, coreClassrooms]);

  useEffect(() => {
    if (copy === true) {
      setAction('copy');
      setCopy(false);
    }
  }, [copy]);

  /* got to classroom view */
  const handleGoClassroom = (groupId: number, externalIdValue: any) => {
    navigateTo('/classroom-details', {
      groupId,
      centerName: centerName || `${translate('settings:CENTER_SECTION.CENTER')}`,
      prev: 'center',
      externalIdValue,
    });
  };

  /* DELETE CLASSROOM functions */
  const handleDeleteFlow = () => {
    setShowDeleteConfirm(true);
  };

  const ConfigResultActionModal = {
    success: {
      title: translate('common:SUCCESS'),
      image: updateSuccessImage,
      configPopsModal: {
        showCloseButton: false,
        onClosedModal: () => {
          if (setShowResultActionModal) setShowResultActionModal(false);
          if (handleOnDeleteClassroom) handleOnDeleteClassroom();
        },
      },
    },
    error: {
      title: translate('common:ERROR'),
      image: updateErrorImage,
      configPopsModal: {
        showCloseButton: true,
        onClosedModal: () => {
          if (setShowResultActionModal) setShowResultActionModal(false);
        },
      },
    },
  };

  const [statusResultActionModal, setStatusResultActionModal] = useState<any>(
    ConfigResultActionModal.error,
  );

  const handleDeleteClassroom = (groupId: number, centerIdValue: number) => {
    setShowDeleteConfirm(false);
    groupService.deleteGroupFromCenter(centerIdValue, groupId)
      .then(() => {
        setStatusResultActionModal(ConfigResultActionModal.success);
      })
      .catch(() => {
        setStatusResultActionModal(ConfigResultActionModal.error);
      })
      .finally(() => setShowResultActionModal(new Date()));
  };

  return (
    <>
      <ClassroomContainer>
        <ClassroomName onClick={() => handleGoClassroom(id, externalId)}>
          {logo ? (
            <ClassroomImg src={logo} />
          ) : (
            <CoverLetter>{name[0]}</CoverLetter>
          )}
          <p>{truncateString(name)}</p>
        </ClassroomName>
        <StudentCount onClick={() => handleGoClassroom(id, externalId)}>
          {translate('settings:CENTER_SECTION.STUDENTS_AMOUNT', {
            amount: studentsLength,
          })}
        </StudentCount>
        <CopyToClipboard onCopy={() => setCopy(true)} text={code}>
          <StyledClassCode>
            <RendererIf condition={code}>
              <Tooltip
                text={<span>{code}</span>}
                contentPopUp={translate('common:CLASSCODE.CLASS_COPIED')}
                showWithExternalAction
                show={action === 'copy'}
              />
              <Copy />
            </RendererIf>
          </StyledClassCode>
        </CopyToClipboard>

        <StyledDropdown>
          <Dropdown
            className="DropdownRemove"
            contentWidth={100}
            noPaddingContent
            content={({ close }: any) => (
              <>
                <Overlay onClick={() => close()} />
                <DropdownContainer>
                  <RendererIf condition={canAddStudents}>
                    <span
                      onClick={() => {
                        handleAddStudent(
                          classroom,
                          coreClassrooms.filter(
                            (item: any) => item.id == externalId,
                          ),
                        );
                        close();
                      }}
                    >
                      {translate('dap:ADD_STUDENT')}
                    </span>
                  </RendererIf>
                  <span
                    onClick={() => {
                      handleGoClassroom(id, externalId);
                      close();
                    }}
                  >
                    {translate('common:DETAILS')}
                  </span>
                  <RendererIf condition={canDeleteItem}>
                    <span className="delete"
                      onClick={() => {
                        handleDeleteFlow();
                        close();
                      }}
                    >
                      {translate('settings:DELETE')}
                    </span>
                  </RendererIf>
                </DropdownContainer>
              </>
            )}
            showIndicator={false}
            title={() => <Dots />}
          />
        </StyledDropdown>
      </ClassroomContainer>
      <Modal
        openModal={showDeleteConfirm}
        title={translate('settings:DELETE_CLASSROOM')}
        onClosedModal={() => {
          setShowDeleteConfirm(false);
        }}
      >
        {() => (
          <DeleteClassroomView
            classroomName={name}
            studentsLength={studentsLength}
            onCancel={() => setShowDeleteConfirm(false)}
            onDelete={() => handleDeleteClassroom(id, centerId)}
          />
        )}
      </Modal>
      <RendererIf condition={showResultActionModal}>
        <ResultActionModal
          styles={{ Image: StylesImageModalResultsUpdateMember }}
          {...statusResultActionModal}
        />
      </RendererIf>
    </>
  );
};

export default ClassroomItem;
